export default function (context) {
  const { mode = 'default' } = context.route.query

  if (context.route.name === 'index') {
    context.app.store.dispatch('root/setCurrentPage', mode)
  } else {
    context.app.store.dispatch('root/setCurrentPage', context.route.name)
  }
}
